import React from "react";
import moment from "moment";
import {
  Col,
  DatePicker,
  Divider,
  Image,
  notification,
  Popover,
  Row,
  Select,
  Table,
  Typography,
} from "antd";

import {
  HistoryModalStyled,
  RewardNameStyled,
  StyledPopupContent,
} from "./styled";
import { CopyOutlined, GiftOutlined, LeftOutlined } from "@ant-design/icons";
import MoneyIcon from "../../../../resources/svgs/division/MoneyIcon";
import Misc from "../../../../utils/misc";
import { TYPE_OPTIONS, STATUS_OPTIONS } from "../../../../constants/profile";
import { MCC_ICON_2 } from "../../../../theme/images";

const { Title } = Typography;
const { RangePicker } = DatePicker;

const HistoryModal = ({
  showModalHistory,
  onCancel,
  divisionTiersHistory,
  isLoading,
  onChangePage,
  filters,
  setFilters,
}) => {
  const getRewardName = (type, record) => {
    return (
      <RewardNameStyled>
        {type === "POINT_BONUS" && (
          <Popover
            content={
              <StyledPopupContent>
                <div
                  style={{ display: "flex", gap: "12px", alignItems: "center" }}
                >
                  <MoneyIcon />
                  <span
                    style={{ fontSize: 20, fontWeight: 700, color: "#156DF2" }}
                  >
                    {" "}
                    POINT BONUS
                  </span>
                </div>
                <div>
                  <span
                    style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}
                  >
                    Bonus point amount:
                  </span>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      justifyContent: "end",
                      padding: " 6px 12px",
                      borderRadius: "20px",
                      border: "1px solid rgba(255, 255, 255, 0.09)",
                      background: "rgba(255, 255, 255, 0.09)",
                      color: "#fff",
                    }}
                  >
                    {record.amount_received}{" "}
                    <Image src={MCC_ICON_2} preview={false} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "4px 0px",
                    }}
                  >
                    <span style={{ color: "#61637A" }}>Spent amount:</span>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <span style={{ color: "#fff" }}>{record.amount}</span>
                      <Image src={MCC_ICON_2} preview={false} />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 4,
                    }}
                  >
                    <span style={{ color: "#61637A" }}>Bonus point rate:</span>
                    <span style={{ color: "#fff" }}>
                      {record.point_bonus_reward}%
                    </span>
                  </div>
                  <span style={{ color: "#61637A" }}>
                    Bonus Points don't go to your wallet—
                    <br />
                    they boost your Division Tier progress
                  </span>
                </div>
              </StyledPopupContent>
            }
            color="#0c0d22"
            placement="top"
            mouseEnterDelay={0.6}
          >
            <span className="reward-name">
              <MoneyIcon />
              {record.point_bonus_reward}% Point bonus
            </span>
          </Popover>
        )}
        {type === "NFT_REWARD" && (
          <Popover
            content={
              <StyledPopupContent>
                <div style={{ display: "flex", gap: 40, alignItems: "center" }}>
                  <div>
                    <div>
                      <GiftOutlined
                        style={{
                          fontSize: 28,
                          color: "#156DF2",
                          marginRight: "8px",
                        }}
                      />
                      <span
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "#156DF2",
                        }}
                      >
                        BADGE
                      </span>
                    </div>

                    <span
                      style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}
                    >
                      NFT Reward
                    </span>
                  </div>
                  <div>
                    <Image
                      src={record.nft_reward_url}
                      alt="NFT Reward"
                      width={64}
                      preview={false}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: " 6px 12px",
                    borderRadius: "20px",
                    border: "1px solid rgba(255, 255, 255, 0.09)",
                    background: "rgba(255, 255, 255, 0.09)",
                    color: "#fff",
                  }}
                >
                  {record.nft_reward_name}
                </div>
              </StyledPopupContent>
            }
            color="#0c0d22"
            mouseEnterDelay={0.6}
            placement="top"
          >
            <span className="reward-name">
              <GiftOutlined
                style={{
                  fontSize: 28,
                  color: "#156DF2",
                  marginRight: "8px",
                }}
              />
              {record.nft_reward_name}
            </span>
          </Popover>
        )}
        {type === "REBATE_RATE" && (
          <Popover
            content={
              <StyledPopupContent className="point-bonus-content">
                <div
                  style={{ display: "flex", gap: "12px", alignItems: "center" }}
                >
                  <MoneyIcon />
                  <span
                    style={{ fontSize: 20, fontWeight: 700, color: "#156DF2" }}
                  >
                    {" "}
                    REBATE RATE
                  </span>
                </div>
                <div>
                  <span
                    style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}
                  >
                    Rebate amount:
                  </span>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      justifyContent: "end",
                      padding: " 6px 12px",
                      borderRadius: "20px",
                      border: "1px solid rgba(255, 255, 255, 0.09)",
                      background: "rgba(255, 255, 255, 0.09)",
                      color: "#fff",
                    }}
                  >
                    {record.amount_received}{" "}
                    <Image src={MCC_ICON_2} preview={false} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "4px 0px",
                    }}
                  >
                    <span style={{ color: "#61637A" }}>Bet amount:</span>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <span style={{ color: "#fff" }}>{record.amount}</span>
                      <Image src={MCC_ICON_2} preview={false} />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 4,
                    }}
                  >
                    <span style={{ color: "#61637A" }}>Rebate rate:</span>
                    <span style={{ color: "#fff" }}>
                      {record.rebate_bonus_reward}%
                    </span>
                  </div>
                </div>
              </StyledPopupContent>
            }
            color="#0c0d22"
            mouseEnterDelay={0.6}
            placement="top"
          >
            <span className="reward-name">
              <MoneyIcon />
              {record.rebate_bonus_reward}% Rebate rate
            </span>
          </Popover>
        )}
      </RewardNameStyled>
    );
  };

  const color = (value) => {
    switch (value) {
      case "INIT":
        return "#177fe7";
      case "WAIT_CONFIRM":
        return "#CA831F";
      case "SUCCESS":
        return "#61D34A";
      case "CANCELED":
        return "rgb(120 117 117)";
      case "TRANSFER_NFT_FAIL":
        return "#C72528";
      case "FAIL":
        return "#C72528";

      default:
        return "#FFF";
    }
  };

  const textStatus = (value) => {
    switch (value) {
      case "INIT":
        return "Init";
      case "WAIT_CONFIRM":
        return "Wait confirm";
      case "SUCCESS":
        return "Success";
      case "CANCELED":
        return "Canceled";
      case "TRANSFER_NFT_FAIL":
        return "Transfer NFT fail";
      case "FAIL":
        return "Fail";

      default:
        return "";
    }
  };

  const handleCopyTransactionHash = (value) => {
    navigator.clipboard.writeText(value).then(() => {
      notification.success({
        message: "Copied transaction hash to clipboard!",
        duration: 2,
      });
    });
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "updated_at",
      key: "updated_at",
      align: "center",
      render: (value) => (
        <span>{value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "-"}</span>
      ),
    },
    {
      title: "Reward",
      dataIndex: "type",
      key: "type",
      align: "left",
      render: (value, record) => getRewardName(value, record),
    },
    {
      title: "Type",
      dataIndex: "tier",
      key: "tier",
      align: "center",
      render: (value) => `Division - tier ${value}`,
    },
    {
      title: "Transaction ID",
      key: "transaction_hash",
      dataIndex: "transaction_hash",
      render: (value) => {
        return value ? (
          <span onClick={() => handleCopyTransactionHash(value)}>
            {Misc.trimPublicAddress(value, 4)}
            <CopyOutlined
              style={{ marginLeft: "4px", fontSize: "16px", cursor: "pointer" }}
            />
          </span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      align: "center",
      width: 120,
      render: (value) => (
        <div
          style={{
            color: color(value),
            border: `1px solid ${color(value)}`,
            padding: 4,
            borderRadius: 8,
          }}
        >
          {textStatus(value)}
        </div>
      ),
    },
  ];

  const handleDateChange = (dates, value) => {
    if (dates) {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        start_date: moment(value[0]).format("YYYY-MM-DD 00:00:00"),
        end_date: moment(value[1]).format("YYYY-MM-DD 23:59:59"),
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        start_date: "",
        end_date: "",
      }));
    }
  };

  return (
    <HistoryModalStyled
      centered
      open={showModalHistory}
      footer={null}
      onCancel={onCancel}
      width="50%"
    >
      <Row justify={"space-between"} align="middle">
        <Col>
          <LeftOutlined onClick={onCancel} />
        </Col>
        <Col>
          <Title level={1} style={{ color: "#156df2", margin: 0 }}>
            REWARD HISTORY
          </Title>
        </Col>
      </Row>
      <Divider
        style={{
          border: "2px solid #156df2",
          margin: "16px 0",
          width: 2,
          borderRadius: 10,
        }}
      />
      <Row className="filter" justify={"space-between"} align="middle">
        <Col span={12}>
          <RangePicker
            className="range-picker"
            placeholder={["Start date", "End date"]}
            onChange={handleDateChange}
            value={[
              filters.start_date ? moment(filters.start_date) : null,
              filters.end_date ? moment(filters.end_date) : null,
            ]}
          />
        </Col>
        <Col span={12}>
          <Row align="middle" justify={"end"} gutter={16}>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: 10,
              }}
            >
              <span style={{ color: "#fff" }}>Status</span>
              <Select
                onChange={(values) =>
                  setFilters((prev) => ({ ...prev, status: values }))
                }
                value={filters.status}
                options={STATUS_OPTIONS}
                style={{ width: "200px" }}
              />
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: 10,
              }}
            >
              <span style={{ color: "#fff" }}>Type</span>
              <Select
                onChange={(values) =>
                  setFilters((prev) => ({ ...prev, type: values }))
                }
                value={filters.type}
                options={TYPE_OPTIONS}
                style={{ width: "200px" }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Table
        dataSource={divisionTiersHistory.items}
        loading={isLoading}
        columns={columns}
        rowKey={"id"}
        scroll={{ y: 520 }}
        pagination={{
          pageSize: 10,
          hideOnSinglePage: true,
          total: divisionTiersHistory.totalCount,
          onChange: onChangePage,
        }}
        className="history-reward-table"
      />
    </HistoryModalStyled>
  );
};

export default HistoryModal;
